import Grid from "@material-ui/core/Grid";
import React from "react";
import { useTranslation } from "react-i18next";

import { Paper, TextField, Typography } from "@material-ui/core";
import { Done } from "@material-ui/icons";
import Build from "@material-ui/icons/Build";
import NotificationsIcon from "@material-ui/icons/Notifications";
import SettingsIcon from "@material-ui/icons/Settings";
import TimelineIcon from "@material-ui/icons/Timeline";
import BadgeLink from "../../Components/BadgeLink";
import Title from "../../Components/Title";
import {
  ECABIN,
  formatTimeWithTZOffset,
  getUser,
  TICKET_PRIORITIES,
  ticketListRowStyle,
  USER_GROUPS,
} from "../../Utils/Common";
import { useStyles } from "../../Utils/Styles";

import { CircularProgress, Tooltip } from "@material-ui/core";
import AttachFileIcon from "@material-ui/icons/AttachFile";
import AttachMoneyIcon from "@material-ui/icons/AttachMoney";
import { useEffect, useState } from "react";
import SortableTable from "../../Components/SortableTable";
import TicketEntry from "../../Components/TicketEntry";
import { getTickets } from "../../Utils/ApiCalls";

export default function MaintenanceModule() {
  const { t } = useTranslation();
  const classes = useStyles();
  const [showTicketEntry, setShowTicketEntry] = useState(false);
  const [refreshList, setRefreshList] = useState("dsfsdfds");
  const [tickets, setTickets] = useState();
  const [selectedTicket, setSelectedTicket] = useState();
  const [filteredList, setFilteredList] = useState();
  const [searchVal, setSearchVal] = useState();

  const badgeLinks = [
    {
      href: "/cpanel/maintenance/ticketarchive",
      title: t("maintenance.ticketArchive"),
      icon: Done,
    },
    {
      href: "/cpanel/maintenance/tickets",
      title: t("maintenance.activeTickets"),
      icon: Build,
    },
    {
      href: "/cpanel/maintenance/statistics",
      title: t("maintenance.statistics"),
      icon: TimelineIcon,
    },
    {
      href: "/cpanel/maintenance/settings",
      title: t("maintenance.settings"),
      icon: SettingsIcon,
      superuser: true,
    },
    {
      href: "/cpanel/alerts",
      title: t("alerts.header"),
      icon: NotificationsIcon,
    },
  ];

  let handleRowClick = (data) => {
    if (data) {
      setSelectedTicket(data);
      setShowTicketEntry(true);
    }
  };

  const handleScrollClick = (event, id) => {};

  useEffect(() => {
    setTickets();
    getTickets(
      {
        AssigneeId: getUser().userId,
        states: ["new", "progress"],
      },
      (result) => {
        setTickets(result.tickets);
      },
    );
  }, [refreshList]);

  useEffect(() => {
    if (searchVal && tickets) {
      var arr = tickets.filter((ti) => {
        if (!ti) {
          return false;
        }
        if (searchVal) {
          return !!Object.keys(ti).find(
            (k) =>
              (ti[k] &&
                String(ti[k])
                  .toLowerCase()
                  .includes(searchVal.toLowerCase())) ||
              (typeof ti[k] === "object" &&
                JSON.stringify(ti[k])
                  .toLowerCase()
                  .includes(searchVal.toLowerCase())),
          );
        }
        return true;
      });

      setFilteredList(arr);
    } else {
      setFilteredList(tickets);
    }
  }, [searchVal, tickets]);

  return (
    <Grid container justify="center" spacing={1}>
      <TicketEntry
        showTicketEntry={showTicketEntry}
        setShowTicketEntry={setShowTicketEntry}
        selectedTicket={selectedTicket}
        setSelectedTicket={setSelectedTicket}
        showHeader={true}
        showSearch={true}
        setRefreshList={setRefreshList}
      />
      <Grid item xs={12}>
        <Paper className={classes.paper}>
          <Grid container spacing={1}>
            {/* All the admin items as badges */}
            {badgeLinks
              .sort((a, b) => {
                return a.title > b.title ? 1 : -1;
              })
              .map((b, i) =>
                b.superuser &&
                getUser().permissionlevel !== USER_GROUPS.SUPER_USER ? null : (
                  <BadgeLink
                    key={i}
                    href={b.href}
                    title={b.title}
                    icon={b.icon}
                  />
                ),
              )}
          </Grid>
        </Paper>
      </Grid>

      <Grid item xs={12}>
        <Paper className={classes.paper}>
          <Grid container spacing={1}>
            <Grid item xs={12}>
              <Title>{t("maintenance.header")}</Title>
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                onChange={(e, v) => {
                  setSearchVal(e.target.value);
                }}
                variant="outlined"
                label={t("search")}
              />
            </Grid>
            <Grid item xs={12}>
              <Title>{t("ticketList.yourTickets")}</Title>
            </Grid>
            <Grid item xs={12}>
              {filteredList && !filteredList.length ? (
                <Typography>{t("ticketList.noActiveTickets")}</Typography>
              ) : filteredList ? (
                <SortableTable
                  tableLayout={"fixed"}
                  headCells={[
                    {
                      id: "attachments",
                      hideFromCsv: true,
                      width: 32,
                      label: "",
                    },
                    {
                      id: "expenses",
                      hideFromCsv: true,
                      width: 32,
                      label: "",
                    },
                    {
                      id: "priority",
                      numeric: false,
                      disablePadding: false,
                      label: t("ticketList.priority"),
                    },
                    {
                      id: "Device.serialNumber",
                      numeric: false,
                      disablePadding: false,
                      label: t("serialNumber"),
                    },
                    {
                      id: "description",
                      numeric: false,
                      disablePadding: false,
                      label: t("ticketList.description"),
                    },
                    {
                      id: "action",
                      numeric: false,
                      disablePadding: false,
                      label: t("ticketList.action"),
                    },
                    {
                      id: "details",
                      numeric: false,
                      disablePadding: false,
                      label: t("ticketList.details"),
                    },
                    {
                      id: "updatedAt",
                      numeric: false,
                      disablePadding: false,
                      label: t("updatedAt"),
                    },
                  ]}
                  getRowStyle={ticketListRowStyle}
                  defaultSortRow={"priority"}
                  handleRowClick={handleRowClick}
                  handleScrollClick={handleScrollClick}
                  maxDataLength={30}
                  tableData={filteredList}
                  rowsPerPage={200}
                  downloadButton={true}
                  header={t("deviceDetails.maintenanceTickets")}
                  specialDataFormatting={[
                    {
                      id: "attachments",
                      format: (data) => {
                        return data ? (
                          <Tooltip title={"This ticket has attached media"}>
                            <AttachFileIcon
                              color="primary"
                              style={{ fontSize: 20 }}
                            />
                          </Tooltip>
                        ) : (
                          ""
                        );
                      },
                    },
                    {
                      id: "expenses",
                      format: (data) => {
                        return data ? (
                          <Tooltip title={"This ticket has expenses"}>
                            <AttachMoneyIcon
                              color="primary"
                              style={{ fontSize: 20 }}
                            />
                          </Tooltip>
                        ) : (
                          ""
                        );
                      },
                    },
                    {
                      id: "state",
                      format: (data) => {
                        return t("ticketList." + data);
                      },
                    },
                    {
                      id: "priority",
                      format: (data) => {
                        return Object.keys(TICKET_PRIORITIES).find(
                          (f) => TICKET_PRIORITIES[f] === data,
                        );
                      },
                    },
                    {
                      id: "createdAt",
                      format: (data) => {
                        return formatTimeWithTZOffset(data, ECABIN);
                      },
                    },
                    {
                      id: "updatedAt",
                      format: (data) => {
                        return formatTimeWithTZOffset(data, ECABIN);
                      },
                    },
                  ]}
                />
              ) : (
                <CircularProgress />
              )}
            </Grid>
          </Grid>
        </Paper>
      </Grid>
    </Grid>
  );
}
